
import { css } from 'lit';
export default css`
:host{
  --pc-container-sm-width:926px;
  --pc-container-md-width:1024px;
  --pc-container-lg-width:1152px;
  --pc-container-xl-width:1280px;
  --pc-container-2xl-width:1440px;

  display:block;
  margin-right:var(--spacing-8);
  margin-left:var(--spacing-8);
}

:host([full-bleed]){
  --pc-container-sm-width:auto;
  --pc-container-md-width:auto;
  --pc-container-lg-width:auto;
  --pc-container-xl-width:auto;
  --pc-container-2xl-width:auto;

  margin-right:auto;
  margin-left:auto;
}

:host([is-hidden='true']){
  display:none;
}

@media (min-width: 992px){
  :host{
    margin-right:auto;
    margin-left:auto;
    max-width:var(--pc-container-sm-width);
  }
}

@media (min-width: 1152px){
  :host{
    max-width:var(--pc-container-md-width);
  }
}

@media (min-width: 1280px){
  :host{
    max-width:var(--pc-container-lg-width);
  }
}

@media (min-width: 1440px){
  :host{
    max-width:var(--pc-container-xl-width);
  }
}

@media (min-width: 1536px){
  :host{
    max-width:var(--pc-container-2xl-width);
  }
}
`;